export default {
    NUM: '^[0-9]*$', //数字
    CHINESE: '^[\u4e00-\u9fa5]{0,}$', //汉字
    CHINESE_ENGLISH_NUM: '^[\u4E00-\u9FA5A-Za-z0-9]+$', //中文、英文、数字但不包括下划线等符号
    ENGLISH_AND_NUM: '^[A-Za-z0-9]+$', //英文和数字
    ENGLISH_AND_NUM_LINE: '^[A-Za-z0-9-_]+$', //英文和数字包括连接线、下划线
    ENGLISH_AND_UNDERLINE: '^[A-Za-z_]+$', //英文和下划线
    ENGLISH_AND_NUM_UNDERLINE: '^[A-Za-z0-9_]+$', //英文、数字包括下划线
    ENGLISH_AND_NUM_SPOT: '^[A-Za-z0-9.]+$', //英文、数字和英文符号.
    CHINESE_ENGLISH_NUM_UDERLINE: '^[\u4E00-\u9FA5A-Za-z0-9_]+$', //中文、英文、数字包括下划线
    CHINESE_ENGLISH_NUM_LINE: '^[\u4E00-\u9FA5A-Za-z0-9-_]+$', //中文、英文、数字包括连接线、下划线
    CAPTION_RULE: '^[\\u4e00-\\u9fa5A-Za-z0-9\\_\\.\\-\\#]+$', //不允许非法字符
    CAPTION_RULE_NULL: '^[\\u4e00-\\u9fa5A-Za-z0-9\\_\\.\\-\\# ]+$', //不允许非法字符(允许空格)
    PORT: '^([1-9][0-9]*)$', //端口号
    URL: '[a-zA-z]+://[A-Za-z0-9/_,.:]*' //URL
};
